import "./WorkWithUs.module.css";
import Header from "@/reusable_sections/Header";
import Benvenuto from "./sections/Benvenuto";
import WhyJoinUs from "./sections/WhyJoinUs";
import Candidatura from "./sections/Candidatura";
import FirmOverview from "./sections/FirmOverview";
import Footer from "@/reusable_sections/Footer";
export default function WorkWithUsPage() {
  return <div>
      <Header />
      <FirmOverview />
      <Benvenuto />
      <WhyJoinUs />
      <Candidatura />
      <Footer />
    </div>;
}